import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BoobleModalService } from 'booble-modal';
import { AuthenticationService } from 'src/app/shared/services';
import { AddContactComponent } from './modals/add-contact/add-contact.component';
import { ResponseTableModel } from 'src/app/domain/models/response-table.model';
import { BankAccountService } from 'src/app/shared/services/bank-account.service';
import { GenericBottomSheetComponent } from 'src/app/shared/components/generic-bottom-sheet/generic-bottom-sheet.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-saved-contacts',
  templateUrl: './saved-contacts.component.html',
  styleUrls: ['./saved-contacts.component.scss'],
})
export class SavedContactsComponent implements OnInit {
  tenant: string = '';
  showDataError: boolean = false;
  haveContacts: boolean = false;
  tableDisplayedColumns: string[];
  pageSize: number = 10;
  loading: boolean = true;
  pageNumber: number = 0;
  totalElements: number;
  userContacts: any = {};
  showTables = true;
  isMobile: boolean;

  @ViewChild('bottomSheetContent') bottomSheetContent: TemplateRef<any>;

  get companyId() {
    return +this.accountService.getCompanyId();
  }

  get individualId() {
    return +this.accountService.getIndividualId();
  }

  constructor(
    private readonly accountService: AuthenticationService,
    private readonly modalService: BoobleModalService,
    private readonly route: ActivatedRoute,
    private readonly bankAccountService: BankAccountService,
    private bottomSheet: MatBottomSheet
  ) {
    this.tableDisplayedColumns = [
      'senderReceiverName',
      'country',
      'currencyContact',
      'type',
      'action',
    ];

    this.bankAccountService.listenerUpdate.subscribe(() => {
      this.bankAccountService.getAllSendersandReceivers().subscribe({
        next: (getResult) => {
          this.loading = false;
          this.userContacts = getResult.data;
          if (getResult.data.length == 0) {
            this.haveContacts = false;
            this.showTables = false;
            this.showDataError = false;
          }
          if (getResult.data.length > 0) {
            this.haveContacts = true;
            this.showTables = true;
            this.showDataError = false;
          }
        },
        error: () => {
          this.showDataError = true;
          this.showTables = false;
          this.loading = false;
        },
      });
    });
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      const result = params.get('tenant');
      const rType = params.get('rType');

      if (result) this.tenant = params.get('tenant');
    });

    this.isMobile = window.innerWidth <= 820 ? true : false;
  }

  reloadPage() {
    window.location.reload();
  }

  openAddContactModal() {
    if (!this.isMobile) {
      this.modalService.present(AddContactComponent);
    } else {
      this.openBottomSheet();
    }
  }

  openBottomSheet() {
    this.bottomSheet.open(GenericBottomSheetComponent, {
      data: { content: this.bottomSheetContent },
    });
  }
}
